import { LanguageCode, RLanguageCode } from '@dh/types';

export const mapLanguageCode = (language: RLanguageCode): LanguageCode => ({
    id: language.id,
    documentId: language.documentId,
    code: language.code,
    nativeName: language.nativeName
});
export const mapLanguageCodes = (languages: RLanguageCode[] | undefined | null): LanguageCode[] =>
    languages?.map(mapLanguageCode) ?? [];

